import React from 'react';
import { PreviewConfig } from 'wix-rich-content-preview';
import styles from './see-full-post.scss';
import { ShowMoreButton } from './show-more-button';

type SeeFullPostProps = {
  lines?: number;
  showToggle?: boolean;
  onPreviewExpand: PreviewConfig['onPreviewExpand'];
  overlayStyles: Record<string, string>;
  onClick?: (e: React.MouseEvent) => void;
};

export const SeeFullPost: React.FC<SeeFullPostProps> = ({
  onPreviewExpand,
  overlayStyles,
  onClick,
  children,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    onClick?.(e);
    onPreviewExpand?.();
  };

  return (
    <div className={styles.container}>
      {children}
      <div className={styles.overlay} style={overlayStyles} onClick={handleClick}>
        <ShowMoreButton onPreviewExpand={onPreviewExpand} />
      </div>
    </div>
  );
};
